import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChatViewerComponent } from 'src/app/components/modais/chat-viewer/chat-viewer.component';

@Component({
  selector: 'app-host-chat-viewer',
  templateUrl: './host-chat-viewer.component.html',
  styleUrls: ['./host-chat-viewer.component.scss']
})
export class HostChatViewerComponent implements OnInit {
  constructor(private modalService: NgbModal, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    let params;
    if (this.router.url.includes('reply-message')) {
      params = this.route.snapshot.params;
    }
    const modalRef = this.modalService.open(ChatViewerComponent,
      {
        scrollable: false,
        windowClass: 'modal-custom-milvus',
        size: 'full-screen',
        keyboard: false,
        backdrop: 'static',
      });

    modalRef.componentInstance.recebeStatusMessage = this.router.url === '/chats-list' ? 1 : Number(params.status_id);
    modalRef.componentInstance.chatIdRecebido = params ? params.chat_id : null;

    modalRef.result.then(() => {
      this.router.navigate(['../']);
    });
  }
}
